import { render, staticRenderFns } from "./CommunicationsList.vue?vue&type=template&id=00cf4556"
import script from "./CommunicationsList.vue?vue&type=script&lang=js"
export * from "./CommunicationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports